// extracted by mini-css-extract-plugin
module.exports = {"container":"AuthLayout_container__6QHHu"};